import { render } from "./MisFavoritos.vue?vue&type=template&id=270061fa"
import script from "./MisFavoritos.vue?vue&type=script&lang=js"
export * from "./MisFavoritos.vue?vue&type=script&lang=js"

import "./MisFavoritos.vue?vue&type=style&index=0&id=270061fa&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__